import { Maybe } from '@csp/csp-common-model';
import { AssessmentAlgorithmV1 } from '@csp/dmdp-api-assessment-dto';
import { ElaasFormulaCodeOrIdentifier } from '@csp/csp-common-rpm-model';
import { AssessmentAlgorithmVersion } from './AssessmentAlgorithmVersion';

export type AssessmentAlgorithm = {
  version: Maybe<AssessmentAlgorithmVersion>;
  code: ElaasFormulaCodeOrIdentifier;
  hashCodeSignature?: string;
};

const from = (algorithmV1?: AssessmentAlgorithmV1): Maybe<AssessmentAlgorithm> =>
  algorithmV1?.code
    ? {
        code: algorithmV1?.code,
        version: algorithmV1?.version,
        hashCodeSignature: algorithmV1?.hashCodeSignature,
      }
    : undefined;
export const AssessmentAlgorithm = {
  from,
};
